import React from 'react'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { LocalGridFragment } from '../../../generated/graphql'
import { calculatorVar } from '../../../apollo/reactive-vars'
import { SystemContainerCharts } from '../../system-container/SystemContainerCharts'
import { providerProperties } from '../../../provider/provider-properties'
import { localGridTypeToProviderTypeMap } from '../../../local-grid/local-grid-util'

type Props = {
  localGrid?: LocalGridFragment
}

export function LocalGridCharts({ localGrid }: Props): React.ReactElement {
  const { t } = useTranslation()
  const calculator = useReactiveVar(calculatorVar)

  if (!localGrid) {
    return <></>
  }

  const localGridCalculator = calculator?.findLocalGrid(localGrid.id)

  if (!localGridCalculator) {
    return <></>
  }

  const demands = localGridCalculator.getPrimaryDemands()
  const energyTypes =
    providerProperties[localGridTypeToProviderTypeMap[localGrid.type]]
      .providesEnergyTypes

  return (
    <SystemContainerCharts
      title={t(`localGrid.${localGrid.type}.tabs.basicInfo.charts`)}
      chartTitlePrefix={t(
        `localGrid.${localGrid.type}.tabs.basicInfo.consumption`,
      )}
      demands={demands}
      energyTypes={energyTypes}
    />
  )
}
